import { Directive, ElementRef, HostListener } from '@angular/core';
@Directive({
  selector: '[appTwoDigitDecimalNumber]'
})
export class TwoDigitDecimaNumberDirective {
	
  
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete',
                'Control','c','v','x'];
  constructor(private el: ElementRef) {
  }
  
  //@Input() noofDigits: Number = 2;
  private regex: RegExp = new RegExp(/^(-?\d+|\d{1,3}(,\d{3})*)(\.\d{0,2})?$/g);
  
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, cut, copy, paste and home keys 
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    let next: string ='';
    if(current.length > 9)
    {
       next = event.key == 'Decimal' ? '.' : event.key;
    }
    else{
       next = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    
    }

    if (event.key == '-') {
      if (position == 0) {
        return;
      }
      else {
        event.preventDefault();
        return;
      }
    }

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

}